// This is App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from './essentials/Navbar';
import HeroSection from './essentials/HeroSection';
import HomePageMain from './components/HomePageMain';
import Footer from './essentials/Footer'
import WorkInProgress from './components/WorkInProgress';


import AboutUs from './components/AboutUs';
import Services from './components/Services';
import Projects from './components/Projects';
import ContactUs from './components/ContactUs';
import Careers from './components/Careers';

function App() {
  return (
    <Router>
      {/* Navbar always visible */}
      <Navbar />

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <HomePageMain />
            </>
          }
        />

        {/* ⭐ Actual About Us Page */}
        <Route path="/about" element={<AboutUs />} />

       
        <Route path="/services" element={<Services />} />
        <Route path="/gallery" element={<WorkInProgress />} />
        <Route path="/projects" element={<Projects  />} />
        <Route path="/career" element={<Careers />} />
        <Route path="/blog" element={<WorkInProgress />} />
        <Route path="/contact" element={<ContactUs   />} />
      </Routes>

      {/* Footer always visible */}
      <Footer />
    </Router>
  );
}

export default App;
